export const LISTAR_GRUPOS_RAMAIS = 'LISTAR_GRUPOS_RAMAIS'
export const LISTAR_GRUPO_RAMAL_SELECIONADO = 'LISTAR_GRUPO_RAMAL_SELECIONADO'
export const LISTAR_RAMAIS = 'LISTAR_RAMAIS'
